import React, {useContext, useState} from "react"
import {ModdApi} from "../../libraries/modd"
import {canCheckout} from "../AddToCart"
import ProductPrice from "../ProductPrice"
import style from "./cartitem.module.css"
import CartContext from "../Context/CartContext";
import {ImgProductModd} from "../Image"

export default ({item}) => {
  const [error, setError] = useState(null)
  const {updateCartInfo} = useContext(CartContext)

  const updateItem = id => {
    const count = document.getElementById(`__${id}`).value

    if (count === "0" || !/^(\d{1,2})$/.test(count)) {
      setError("1〜99までの個数を半角数字で入力してください")
      return
    } else {
      setError(null)
    }

    ModdApi.get(`/UpdateItemsQty?shopId=${process.env.MODD_SHOP_ID}&proCataNo=${id}&proQty=${count}`)
    .then(res => updateCartInfo(res.data))
    .catch(err => console.error(err))
  }

  const deleteItem = id => {
    ModdApi.get(`/RemoveItems?&shopId=${process.env.MODD_SHOP_ID}&proCataNo=${id}`)
    .then(res => updateCartInfo(res.data))
    .catch(err => console.error(err))
  }

  return (
    <div className={style.item}>
      <div>
        <div>
          <a href={`/product/detail?id=${item.ProCataNo}`} style={{width: "80px", height: "80px"}}>
            <ImgProductModd Hin={item.ProCataNo}/>
          </a>
        </div>
        <div>
          <a href={`/product/detail?id=${item.ProCataNo}`}>{item.ProTitle}</a>
          <ProductPrice price={item.ProPrice}/>
        </div>
      </div>
      {canCheckout(item.Note) === false && <p className="comment error">{item.Note}</p>}
      <div>
        <div>
          <p>数量 <input type="number" defaultValue={item.ProItemQty} max="99" min="1" maxLength="2" id={`__${item.ProCataNo}`}/> <button type="button" className={style.buttonUpdate} onClick={() => updateItem(item.ProCataNo)}>更新</button></p>
          {error && <p className="comment error">{error}</p>}
        </div>
        <div>
          <button type="button" className={style.buttonDelete} onClick={() => deleteItem(item.ProCataNo)}>削除</button>
        </div>
      </div>
    </div>
  )
}